import { engineRequest } from './http';

// Free slots per day for the ticket's person in charge. Query: `from`, `to`
// (YYYY-MM-DD, at most 62 days), `minutes` (15-480).
export const getSlots = (ticketId, params) =>
  engineRequest({ path: `/tickets/${ticketId}/slots`, params });

// `{mode: 'offer' | 'book', purpose, minutes, slots: [{date, start}]}`: offer
// takes 1-3 slots, book exactly one. Answers `{visit, ticket}`.
export const createVisit = (ticketId, body) =>
  engineRequest({
    method: 'post',
    path: `/tickets/${ticketId}/visits`,
    data: body,
  });

const visitAction = (visitId, action, body) =>
  engineRequest({
    method: 'post',
    path: `/visits/${visitId}/${action}`,
    data: body || {},
  });

// Books an option (1-3) of the open offer for the tenant, agreed by phone.
export const confirmVisit = (visitId, option) =>
  visitAction(visitId, 'confirm', { option });

export const rescheduleVisit = (visitId, body) =>
  visitAction(visitId, 'reschedule', body);

export const cancelVisit = (visitId, reason) =>
  visitAction(visitId, 'cancel', reason ? { reason } : {});

export const completeVisit = visitId => visitAction(visitId, 'complete');

// Only after the visit's start time (409 `visit_not_started` before).
export const noShowVisit = (visitId, reason) =>
  visitAction(visitId, 'no-show', reason ? { reason } : {});

export const withdrawVisit = (visitId, reason) =>
  visitAction(visitId, 'withdraw', reason ? { reason } : {});
